import { useCallback } from 'react';
import { observer } from 'mobx-react';

import { AmountHelper } from 'modules/common/values';
import { Button, Field, TextInput } from 'modules/common/ui';

import { Field as FormField } from '../../../types/Field';

import { FormRoot } from '../Form.Root';
import { Store } from '../../../stores';
import { FormButton, FormInput } from '../../Form';
import { schema } from '../PayForm.Schema';
import { PaymentType } from '../../../../repay';

const Form = () => {
  const store = Store.use();

  const onPay = useCallback(
    (data: any) => {
      store.submitPayForm(
        AmountHelper.create(Number(data?.amount)),
        PaymentType.ANY,
      );
    },
    [store],
  );

  const initialValues = {
    amountFull: store.amountFull,
  };

  return (
    <FormRoot schema={schema} onSubmit={onPay} initialValues={initialValues}>
      <FormInput>
        <Field
          label="Сумма к оплате"
          htmlFor="amount"
          name={FormField.AMOUNT}
          error={store.errorMessage}
        >
          <TextInput
            id={FormField.AMOUNT}
            inputMode="numeric"
            name={FormField.AMOUNT}
            placeholder="Введите сумму"
            invalid={Boolean(store.errorMessage)}
            mask={Number}
            scale={2}
            signed={false}
            padFractionalZeros
            mapToRadix={[',']}
            radix="."
          />
        </Field>
      </FormInput>
      <input type="text" name={FormField.AMOUNT_FULL} hidden />
      <FormButton>
        <Button variant="filled" type="submit">
          Продолжить оплату
        </Button>
      </FormButton>
    </FormRoot>
  );
};

export const FormAny = observer(Form);
